import React from "react";
import { MobergFontFamily } from "../../../Components/MobergFont/MobergFont";
import { MdArrowBack, MdLogout } from "react-icons/md";
import { IconButton } from "@mui/material";

const RMMobileStickyHeader = ({ 
    title,
    onBack,
    onLogout,
    showBackButton = false
}) => {
    return (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            padding: "12px 16px",
            backgroundColor: "#ffffff",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            borderBottom: "1px solid #E5E5E5",
            zIndex: 1000
        }}>
            {showBackButton && (
                <IconButton
                    onClick={onBack}
                    style={{
                        color: "#5B5B5B",
                        padding: "8px"
                    }}
                >
                    <MdArrowBack size={20} />
                </IconButton>
            )}
            
            <h2 style={{
                fontWeight: "600",
                fontSize: "16px",
                color: "#5B5B5B",
                fontFamily: MobergFontFamily.HEADER,
                margin: 0,
                letterSpacing: "-0.3px",
                flex: 1
            }}>
                {title}
            </h2>
            
            <IconButton
                onClick={onLogout}
                style={{
                    color: "#FF3B30",
                    padding: "8px"
                }}
            >
                <MdLogout size={20} />
            </IconButton>
        </div>
    );
};

export default RMMobileStickyHeader;

